import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../../components/Icon";
import { showSuccess, showError } from "../../../../services/toast.service";

const Panel = ({ selectedTutors = [], onDeleteSelected, onClearSelection }) => {
  const handleDeleteSelected = async () => {
    if (!selectedTutors.length) return;
    
    try {
      await onDeleteSelected(selectedTutors);
      showSuccess(`${selectedTutors.length} tuteur(s) supprimé(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des tuteurs');
      console.error(error);
    }
  };

  // Ne pas afficher le panel s'il n'y a pas de tuteurs sélectionnés
  if (!selectedTutors.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedTutors.length} tuteur{selectedTutors.length > 1 ? 's' : ''} sélectionné{selectedTutors.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleDeleteSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
